export default __webpack_public_path__ + "static/media/pear.6289d7aa.jpg";